import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function Agitator() {
  return <section className="bg-white py-12 md:py-24 px-4" data-id="element-15">
      <motion.div initial={{
      opacity: 0,
      y: 30
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto space-y-8 md:space-y-12" data-id="element-16">
        <div className="text-center" data-id="element-17">
          <div className="inline-flex items-center justify-center p-3 bg-rose-100 rounded-full mb-6" data-id="element-18">
            <AlertCircle className="w-6 h-6 text-rose-500" data-id="element-19" />
          </div>
          <span className="block text-rose-500 font-bold uppercase tracking-wider text-sm mb-2" data-id="element-20">
            La Trampa del "Sin Tiempo"
          </span>
          <h2 className="text-3xl md:text-4xl text-dark font-display font-extrabold tracking-headline leading-tight" data-id="element-21">
            Por qué lo que has intentado hasta ahora{' '}
            <span className="text-rose-500" data-id="element-22">no ha funcionado</span>
          </h2>
        </div>

        <div className="space-y-6 text-lg md:text-xl text-body leading-relaxed" data-id="element-23">
          <p data-id="element-24">
            La mayoría de las mamás latinas en este país caen en la misma
            trampa:{' '}
            <strong className="font-bold text-dark" data-id="element-25">
              o se cansan en trabajos de 10 horas que odian, o pierden dinero en
              negocios multinivel
            </strong>{' '}
            que prometen mucho y no dan nada.
          </p>

          <p data-id="element-26">
            Te dicen que para tener un negocio digital debes ser{' '}
            <strong className="font-bold text-dark" data-id="element-27">"experta"</strong>, saber
            diseñar o pasarte meses escribiendo un libro.
          </p>

          <div className="bg-gradient-to-r from-primary/10 to-transparent border-l-4 border-primary rounded-r-[20px] p-8 mt-10" data-id="element-28">
            <p className="font-bold text-2xl text-dark" data-id="element-29">
              Eso es mentira.{' '}
              <span className="text-primary block mt-2" data-id="element-30">
                En 2026, el esfuerzo manual es cosa del pasado.
              </span>
            </p>
          </div>
        </div>
      </motion.div>
    </section>;
}